/**
 * FaseB B0 — card colapsável em mobile, sempre aberto em desktop (≥768px).
 *
 * Em mobile (<md):
 *   - Botão clicável com title + (opcional) subtitle + chevron rotacional.
 *   - Conteúdo escondido por default (override via `defaultOpen`).
 *
 * Em desktop (≥md):
 *   - Título estático (h2) acima do conteúdo, opcional.
 *   - Conteúdo sempre visível.
 *
 * Uso:
 *   <MobileCollapse title="FOCO DE HOJE" defaultOpen={false}>
 *     {conteúdo}
 *   </MobileCollapse>
 *
 * Se o filho já tem um título interno (ex.: HeroFocusCard com h3 próprio),
 * passar `title=""` ou `desktopTitle={false}` pra omitir o h2 desktop.
 */
import { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function MobileCollapse({
  title,
  subtitle,
  defaultOpen = false,
  desktopTitle = true,
  className = "",
  children,
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={className}>
      {/* Mobile (<md): botão clicável */}
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className="md:hidden w-full flex items-center justify-between px-4 py-3 rounded-xl bg-white/[0.04] border border-white/[0.06] hover:bg-white/[0.06] transition-colors"
        data-testid="mobile-collapse-toggle"
      >
        <div className="flex flex-col items-start min-w-0">
          <span className="text-sm font-medium text-white truncate">{title}</span>
          {subtitle && (
            <span className="text-xs text-slate-400 truncate">{subtitle}</span>
          )}
        </div>
        <ChevronDown
          aria-hidden="true"
          className={`w-4 h-4 text-slate-400 transition-transform shrink-0 ml-2 ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>

      {/* Desktop (≥md): título estático (h2) — só se desktopTitle e title forem truthy */}
      {desktopTitle && title && (
        <h2 className="hidden md:block text-lg font-semibold text-white mb-2">
          {title}
        </h2>
      )}

      {/* Conteúdo: visível em mobile só quando aberto, sempre em desktop */}
      <div className={`md:block ${open ? "block mt-2" : "hidden"}`}>
        {children}
      </div>
    </div>
  );
}
